export class SetErrorAction {
  public static readonly type = '[Project/Forms/List] SetErrorAction';
  constructor(public readonly error: Error) {}
}
